module.exports = __webpack_public_path__ + "f84db346267d48786945fcc7d5d30df9.png";